import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
  selector: 'app-confirmation-elton-modal',
  templateUrl: './confirmation-elton-modal.component.html',
  styleUrls: ['./confirmation-elton-modal.component.scss'],
})
export default class ConfirmationEltonModalComponent {
  @Input() open = false

  @Output() closed = new EventEmitter<void>()

  openAppStore(): void {
    window.open('https://apps.apple.com/no/app/elton/id1521424253', '_blank')
  }

  openGooglePlay(): void {
    window.open('https://play.google.com/store/apps/details?id=no.vg.lab.zapp', '_blank')
  }
}
